import { useState } from 'react';
import { IconButton } from '@mui/material';

import AlxButton from '../alx-components/button';
import { icons } from '../../assets/icons/icons';
import { NavButtonsStyle } from './nav-buttons-style';

interface INavButtons {
  prevStep: () => void;
  nextStep: () => void;
  nextText: string;
  showPrevButton?: boolean;
  disableNext?: boolean;
}

const NavButtons: React.FC<INavButtons> = ({
  prevStep,
  nextStep,
  nextText,
  showPrevButton = true,
  disableNext = false,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [visible, setVisible] = useState(true);

  return (
    <NavButtonsStyle className={!visible ? 'hide' : ''} id="navBtns">
      {showPrevButton && (
        <div className="nav-buttons-item with-icon">
          <IconButton className={'secondary '} onClick={() => prevStep()} data-cy="back-step-button">
            <img src={icons.arrowLeftIcon} alt="" />
          </IconButton>
        </div>
      )}
      <div className="nav-buttons-item">
        <AlxButton onClick={() => nextStep()} data-cy="next-step-button" disabled={disableNext}>
          {nextText}
        </AlxButton>
      </div>
    </NavButtonsStyle>
  );
};

export default NavButtons;
